<template>
  <div v-if="config">
    <v-row>
      {{editedID}}
      <v-col
        v-for="field of config.form"
        :key="field.ID"
        cols="12"
        sm="12"
      >

        <div
          v-if="field.FieldType === 'richtext'"
        >
          <small>
            {{ getTranslation(field.Name, locale) }} :
          </small>
          <vue-editor
            :label="getTranslation(field.Name, locale)"
            v-model="editedItem[field.ID]"
            :editor-toolbar="customToolbar"
            style="z-index: 3000;border-radius: 5px;"
            :style="{ border: `${borderSize}px solid ${editorBorderColor} !important`, padding: `${borderMargin}px` }"
            @input="(...args) => { handleChangeRichtext() }"
            @focus="handleEditorChangeFocus(true)"
            @blur="handleEditorChangeFocus(false)"
          />
        </div>
        <v-text-field
          v-if="field.FieldType === 'text'"
          :label="getTranslation(field.Name, locale)"
          v-model="editedItem[field.ID]"
          hide-details
          outlined
          @input="handleChange"
        />
        <div
          v-if="['imagen', 'polaroid'].indexOf(field.FieldType) >= 0"
        >
          <small>
            {{ getTranslation(field.Name, locale) }} :
          </small>
          <select-image 
            :key="lmu"
            :image="editedItem[field.ID]"
            :onChange="(v) => handleChangeImage(field.ID, v)"
            :locale="locale"
            :imageWidth="field.Width"
            :imageHeight="field.Height"
            :aspectRatio="field.Width/field.Height"
            :folder="config.WorkspaceID"
            style="margin-top: 0; margin-left: 0px;width:100%;"
          />
        </div>
      </v-col>
    </v-row>
  </div>
</template>
<script>
const fullToolbar = [
  // [{ font: ["arial"] }],
  // [{ font: [] }],
  // [{ font: [{ list: "ordered" }, { list: "bullet" }, { list: "check" }] }],
  [{ header: [false, 1, 2, 3, 4, 5, 6] }],
  [{ size: ["small", false, "large", "huge"] }],
  // [{ size: ["small", false, "large", "huge"] }],
  ["bold", "italic", "underline", "strike"],
  [
    { align: "" },
    { align: "center" },
    { align: "right" },
    { align: "justify" }
  ],
  [{ header: 1 }, { header: 2 }],
  ["blockquote", "code-block"],
  [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
  [{ script: "sub" }, { script: "super" }],
  [{ indent: "-1" }, { indent: "+1" }],
  [{ color: [] }, { background: [] }],
  ["link",
    // "image",
    // "formula"
  ],
  [{ direction: "rtl" }],
  ["clean"]
]
import { VueEditor } from 'vue2-editor'
import api from '@/services/api'
import utils from '@/services/utils'
import SelectImage from '@/components/selectImage/Index'
export default {
  components: {
    VueEditor,
    SelectImage,
  },
  props: {
    editedID: {
      type: String,
      default: null,
    },
    customContentTypeID: {
      type: String,
      required: true,
    },
    isClone: {
      type: Boolean,
      default: false,
    },
    locale: {
      type: String,
      required: true,
    },
    onChange: {
      type: Function,
      required: true,
    },
  },
  data: () => ({
    lmu: null,
    config: null,
    editedItem: {},

    customToolbar: fullToolbar,
    borderMargin: '0',
    borderSize: '1',
    editorBorderColor: 'gray',
  }),
  watch: {
    editedID () {
      this.handleGetData()
    },
    customContentTypeID () {
      this.handleGetFormData()
    },
  },
  mounted () {
    this.handleGetFormData()
    this.handleGetData()
  },
  methods: {
    getTranslation (v, locale) {
      return utils.getTranslation(v, locale)
    },
    async handleGetData () {
      try {
        this.editedItem={}
        if (!this.editedID || !this.config) return
        this.editedItem = await new Promise((resolve, reject) => api.getAllWithoutLimit ('dviewcontent', `v1/private/custom-content-types/${this.editedID}/values`)
          .then(response => {
            if (!response) return
            const result = {}
            for (const field of this.config.form) {
              const aux = response.filter(x => x.FieldID === field.ID).map(item => item.Value).shift()
              result[field.ID] = aux
            }
            resolve(result)
          })
          .catch (error => {
            console.log(error)
            reject(error)
          }))
        if (this.isClone) this.handleChange()
      } catch (error) {
        console.log(error)
      }
    },
    async handleGetFormData () {
      try {
        this.config = null
        this.config = await new Promise((resolve, reject) => api.getItem ('dviewcontent', `v1/private/custom-content-types/`, this.customContentTypeID)
          .then(response => {
            if (!response) return
            response.form = response.form.map(item => {
              item.Name = item.Name ? JSON.parse(item.Name) : null
              return item
            })
            resolve(response)
          })
          .catch (error => {
            console.log(error)
            reject(error)
          }))
        this.handleGetData()
        if (this.isClone) this.handleChange()
      } catch (error) {
        console.log(error)
      }
    },
    handleChangeImage (id, v) {
      this.editedItem[`newImage_${id}`] = v
      this.editedItem[id]= v.base64
      this.lmu = new Date().toISOString()
      this.handleChange()
    },
    handleChange () {
      this.onChange(this.editedItem)
    },
    // ini richtext
    handleChangeRichtext () {
      this.handleChange()
    },
    handleEditorChangeFocus (v) {
      this.borderMargin = v ? '0' : '1'
      this.borderSize = v ? '2' : '1'
      this.editorBorderColor = v ? this.$vuetify.theme.themes.light.primary : 'gray'
    },
    // end richtext
  },
}
</script>
<style>
  .ql-snow.ql-toolbar {
    left: 0px !important;
    padding-top: 13px !important;
    padding-right: 23px !important;
    border: 0 !important;
  }
  #quill-container {
    border: 0;
    border-top: 1px solid lightgray !important;
  }
  .quillWrapper:focus {
    border-color: var(--v-primary-base) !important;
  }
  .toolbarTabs .v-toolbar__content {
    height: 0px !important;
  }
  /* .ql-font span[data-value="arial"]::before {
    font-family: "Arial";
    content: "Arial" !important;
  } */
</style>
